import React from 'react';
import EcxSurveyEditor  from "../helpers/ecxsurvey/EcxSurveyEditor";

const SurveyCreate = () => {
    const handleSave = () => {}

    return (
        <div>
            <EcxSurveyEditor onSave={handleSave}/>
        </div>
    );
};

export default SurveyCreate;